/* Market To Your Door — rolling cart + fly-to-cart animation */
(function () {
  function cartIcon() {
    return document.getElementById('cart-icon-bubble');
  }
  function rollCart() {
    var icon = cartIcon();
    if (!icon) return;
    icon.classList.remove('cart-rolling');
    void icon.offsetWidth; /* restart the animation */
    icon.classList.add('cart-rolling');
    setTimeout(function () {
      icon.classList.remove('cart-rolling');
    }, 950);
  }
  function flyToCart(img, target) {
    try {
      var r1 = img.getBoundingClientRect();
      var r2 = target.getBoundingClientRect();
      if (!r1.width) {
        rollCart();
        return;
      }
      var clone = img.cloneNode();
      clone.className = 'mtyd-fly-img';
      clone.style.left = r1.left + 'px';
      clone.style.top = r1.top + 'px';
      clone.style.width = r1.width + 'px';
      clone.style.height = r1.height + 'px';
      document.body.appendChild(clone);
      var dx = r2.left + r2.width / 2 - (r1.left + r1.width / 2);
      var dy = r2.top + r2.height / 2 - (r1.top + r1.height / 2);
      var anim = clone.animate(
        [
          { transform: 'translate(0, 0) scale(1)', opacity: 1 },
          {
            transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(0.5)',
            opacity: 0.9,
            offset: 0.6,
          },
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.1)', opacity: 0.3 },
        ],
        { duration: 700, easing: 'cubic-bezier(0.3, 0.7, 0.4, 1)' }
      );
      anim.onfinish = function () {
        clone.remove();
        rollCart();
      };
    } catch (err) {
      rollCart();
    }
  }
  /* fly-to-cart when an add-to-cart button is clicked */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[name="add"], .product-form__submit, [data-add-to-cart]');
    if (!btn) return;
    var target = cartIcon();
    if (!target) return;
    var img = null;
    var form = btn.closest('form');
    if (form) {
      var scope =
        form.closest('[id^="MainProduct-"]') ||
        form.closest('.product') ||
        form.closest('.card-wrapper');
      if (scope) img = scope.querySelector('img');
    }
    if (!img) img = document.querySelector('.product__media img');
    if (img) flyToCart(img, target);
    else rollCart();
  });
  /* roll whenever the cart count badge changes (quick-add, etc.) */
  function countText() {
    var b = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    return b ? b.textContent.trim() : null;
  }
  var lastCount = countText();
  setInterval(function () {
    var c = countText();
    if (c !== lastCount) {
      lastCount = c;
      rollCart();
    }
  }, 600);
  /* a little roll when opening the cart, just for fun */
  document.addEventListener('click', function (e) {
    if (e.target.closest('#cart-icon-bubble')) {
      setTimeout(rollCart, 150);
    }
  });
})();
